<template>
  <b-list-group>
    <b-list-group-item
      v-for="certification in certifications"
      v-if="certification.declined !=null"
      class="mb-3"
      :key="(certification.contact || certification.user).id"
      :variant="certification.declined ? 'danger' : 'success'"
    >
      {{certification.declined ? 'Declined Certification ' : 'Certified '}}
      by {{(certification.contact || certification.user).firstName}}
       {{(certification.contact || certification.user).lastName}} on
      {{certification.createdAt | dateTimeString}}
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Certifications',
  computed: {
    ...mapState('Notification', {
      certifications: state => state.certifications,
    }),
  },
  created() {
    this.$store.dispatch('Notification/fetchCertifications');
  },
};
</script>
